// src/i18n/useLanguageSettings.js
// Admin-idarəli dil ayarlarını (public API) bir dəfə çəkir və switcher-ə verir.
// Resurslar hələ də bundle-dır (flicker yoxdur) — bu API YALNIZ görünürlük +
// fallback qaydalarını idarə edir, tərcümə mətnini yox.
import { useEffect, useState } from 'react'
import api from '../api/api'
import { changeLanguage, DEFAULT_LANG, SUPPORTED_LANGS, LANG_STORAGE_KEY } from './index'

// Bütün switcher nüsxələri arasında paylaşılan modul-səviyyə keş (tək fetch).
let cache = null
let inflight = null
const subscribers = new Set()
const notify = () => subscribers.forEach((fn) => fn(cache))

const readStored = () => {
    try { return localStorage.getItem(LANG_STORAGE_KEY) } catch (_) { return null }
}

// Fallback qaydaları:
//  - multiLanguageEnabled=false → default dilə keç.
//  - seçilmiş dil artıq aktiv deyilsə → fallback (yoxdursa default) dilə keç.
const applyFallback = (data) => {
    try {
        const def = SUPPORTED_LANGS.includes(data.defaultLanguage) ? data.defaultLanguage : DEFAULT_LANG
        const fb = SUPPORTED_LANGS.includes(data.fallbackLanguage) ? data.fallbackLanguage : def
        const activeCodes = (data.languages || []).map((l) => l.code).filter((c) => SUPPORTED_LANGS.includes(c))

        if (!data.multiLanguageEnabled) { changeLanguage(def); return }
        const stored = readStored()
        if (stored && activeCodes.length && !activeCodes.includes(stored)) {
            changeLanguage(activeCodes.includes(fb) ? fb : def)
        }
    } catch (_) { /* ignore */ }
}

export const fetchLanguageSettings = () => {
    if (inflight) return inflight
    inflight = api.get('/public/language-settings')
        .then(({ data }) => {
            if (data && data.success) { cache = data; applyFallback(data); notify() }
            return cache
        })
        .catch(() => cache) // Şəbəkə xətası → mövcud bundle davranışı (AZ/EN) qalır
        .finally(() => { inflight = null })
    return inflight
}

// Switcher-lər bunu istifadə edir. cache null olduqda (yüklənməmiş/xəta)
// switcher mövcud AZ/EN davranışına geri düşür — sayt işləməyə davam edir.
export const useLanguageSettings = () => {
    const [state, setState] = useState(cache)
    useEffect(() => {
        subscribers.add(setState)
        if (cache) setState(cache)
        else fetchLanguageSettings()
        return () => { subscribers.delete(setState) }
    }, [])
    return state
}
